import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import SessionExpiredPopup from "./components/SessionExpiredPopup";
import { UserContext } from "../../UserContext";
import { useNavigate } from "react-router-dom";
// import CoachSelectionPopup from "./components/CoachSelectionPopup";
import EndSessionPopup from "./components/EndSessionPopup";
import lumi from "../../assets/aWiseTurtle.webp";
import ronald from "../../assets/aStudiusTurtle.webp";
import eira from "../../assets/Coach4.jpg";
import InsightPopup from "./components/InsightPopup";
import Mood from "./components/WhatAreYouFeelingToday";
import sizun from "../../assets/sizun.png";
import Confetti from "react-confetti";
import ActionPopup from "./components/ActionPopup";
import {
  Gift,
  PartyPopper,
  Flag,
} from "lucide-react";
import FocusPopup from "./components/FocusPopup";
import OnboardingMain from "../Onboarding/Onbaording_main";

import { motion } from "framer-motion";
import Conclusion from "./components/ConclusionPopup";
import { useLocation } from "react-router-dom";
import { useSimpleWindowCloseHandler } from "../../../src/utils/useWindowCloseHandler.js";
import { useMemo } from "react";

const suggestions = [
  "Sometimes clarity doesn’t come from answers — it comes from asking a better question.",
  "You are not your thoughts. You’re the one observing them.",
  "Most of what feels stuck... started as protection.",
  "You’re not overreacting — you’re carrying an old wound that wants to be seen.",
  "Pause. Not to fix — but to listen.",
  "You don’t have to figure it all out. You just have to meet yourself honestly.",
  "Some loops don’t need solving. They need space.",
  "Beneath every pattern is a part of you that had a good reason.",
  "The story you keep repeating might be waiting to be rewritten.",
  "What would change if you gave yourself permission to not be ‘fine’?",
  "You’re allowed to feel lost while still moving forward.",
  "Sometimes the insight isn’t new. It’s just finally heard.",
  "The part of you that resists may be the part that needs the most compassion.",
  "The right words won’t always come. But the right silence might.",
  "Even your silence is speaking. Are you listening?",
  "Not knowing is not failing. It’s space.",
  "Progress isn’t always visible — but it’s still happening.",
  "You’re not stuck — you’re just in a moment that hasn’t unfolded yet.",
  "When clarity feels far, curiosity is enough.",
  "You don’t need to be ready. You just need to be honest.",
  "Trust the pause — something new often begins there.",
  "Sometimes the next step isn’t forward. It’s inward.",
  "Even confusion is part of clarity’s process.",
  "You’re not behind. You’re just becoming.",
];
// const coachImages = { lumi, ronald, eira };

const ChatWindow = ({
  embedded = true,
  onExitSession,
  onSessionComplete,
  userId,
  subsectionId,
  currentModule = null,
  ...rest
}) => {

  // const textareaRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [newSession, setNewSession] = useState("");
  const [botResponse, setBotResponse] = useState("");
  const [userTyping, setUserTyping] = useState(true); // eslint-disable-line no-unused-vars
  const [botTyping, setBotTyping] = useState(false);
  const [responseReceived, setResponseReceived] = useState(false); // eslint-disable-line no-unused-vars
  const [showToast, setShowToast] = useState(false); // eslint-disable-line no-unused-vars
  const [thubsUp, setthubsUp] = useState(true); // eslint-disable-line no-unused-vars
  const [thubsDown, setthubsDown] = useState(true); // eslint-disable-line no-unused-vars
  const [sessionExpired, setSessionExpired] = useState(false);
  const [sessionEnd, setSessionEnd] = useState(false);
  const [sessionExtend, setSessionExtend] = useState(false);
  const [userReaction, setUserReaction] = useState(null); // eslint-disable-line no-unused-vars
  const [image, setImage] = useState(null); // eslint-disable-line no-unused-vars
  const [showCoachPopup, setShowCoachPopup] = useState(false);
  const [selectedCoach, setSelectedCoach] = useState(null); // eslint-disable-line no-unused-vars
  const [startTime, setStartTime] = useState(null);
  const [wpmHistory, setWpmHistory] = useState([]);
  const [totalResponses, setTotalResponses] = useState(0); // eslint-disable-line no-unused-vars
  const [botQuestionTimestamp, setBotQuestionTimestamp] = useState(null);
  const [comprehensionTimes, setComprehensionTimes] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false); // eslint-disable-line no-unused-vars
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupSummary, setPopupSummary] = useState("");
  const [popupOptions, setPopupOptions] = useState([]);
  const [insightPopup, setInsightPopup] = useState(false);
  const [insightPopupData, setInsightPopupData] = useState("");
  const [insightStepNumber, setinsightStepNumber] = useState(null);
  const [insightSummery, setinsightSummery] = useState("");
  const [actionPopup, setactionPopup] = useState(false);
  const [actionPopupOptions, setActionPopupOptions] = useState("");
  const [actionSummery, setActionSummery] = useState("");
  const [remainingTime, setRemainingTime] = useState(null);
  const [popupAlternatePerspective, setPopupAlternatePerspective] =
    useState("");
  const [popupCoachBackstory, setPopupCoachBackstory] = useState(
    // eslint-disable-line no-unused-vars
    "I am your guardian angel in this conversation, guiding you towards clarity and growth"
  ); // eslint-disable-line no-unused-vars
  const [conclutionPopup, setConclutionPopup] = useState(false);
  const [selectedFocusChoice, setSelectedFocusChoice] = useState(""); // eslint-disable-line no-unused-vars
  const [isPopupRequired, setIsPopupRequired] = useState(0);
  const [isRegenerating, setIsRegenerating] = useState(false); // eslint-disable-line no-unused-vars
  const [hasConfettiShown, setHasConfettiShown] = useState(false);
  const [session_Goal, setSession_Goal] = useState("");
  const [showConfetti, setShowConfetti] = useState(false);
  // const coachImages = useMemo(() => ({ lumi, ronald, eira }), [lumi, ronald, eira]);
  const coachImages = useMemo(() => ({ lumi, ronald, eira }), []);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const stepNumber = "";
  const [showOptions, setShowOptions] = useState(false);
  const [totalStepNumber, setTotalStepNumber] = useState(false);
  const [showMood, setShowMood] = useState(false);
  const [currentMood, setCurrentMood] = useState("more");

  const [actionData, setActionData] = useState("");
  const [insightData, setInsightData] = useState("");
  const [insightFromUser, setInsightFromUser] = useState("");
  const [conclusionData, setConclusionData] = useState(""); // eslint-disable-line no-unused-vars

  const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;
  const disabledButton = newMessage.trim() === ""; // eslint-disable-line no-unused-vars

  const [popupProgress, setPopupProgress] = useState({
    focus: false,
    insight: false,
    action: false,
  });

  const [progress, setProgress] = useState({
    focus: 0,
    insight: 0,
    action: 0,
    overall: 0,
  });

  // select suggestion
  const [selectedSuggestion, setSelectedSuggestion] = useState("");

  const location = useLocation();
  // For new integration, proceed without story id
  const story_id = null;

  useSimpleWindowCloseHandler(
    newSession,
    user?.user_id,
    apiBaseURL,
    !!newSession
  );

  const calculateAverageWPM = useCallback(() => {
    if (wpmHistory.length === 0) return 0;
    const totalWPM = wpmHistory.reduce((total, current) => total + current, 0);
    return totalWPM / wpmHistory.length;
  }, [wpmHistory]);

  const calculateAverageComprehensionTime = useCallback(() => {
    if (comprehensionTimes.length === 0) return 0;
    const totalComprehensionTime = comprehensionTimes.reduce(
      (total, current) => total + current,
      0
    );
    return totalComprehensionTime / comprehensionTimes.length; // Average time in milliseconds
  }, [comprehensionTimes]);

  const saveSessionData = useCallback(
    async (avgWPM, avgComprehensionTime) => {
      try {
        const response = await fetch(
          `${apiBaseURL}/users/session/${newSession}/update`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              avgWPM: avgWPM,
              comprehension_time: avgComprehensionTime,
            }),
          }
        );

        // Check if the request was successful
        if (!response.ok) {
          throw new Error("Failed to update session stats");
        }

        const data = await response.json();
        console.log("Session updated:", data);

        return data; // Return data if needed
      } catch (error) {
        console.error("Error updating session stats:", error);
      }
    },
    [apiBaseURL, newSession]
  );

  useEffect(() => {
    if (botTyping) {
      const randomIndex = Math.floor(Math.random() * suggestions.length);
      setSelectedSuggestion(suggestions[randomIndex]);
    }
  }, [botTyping]);

  const updateProgress = useCallback(
    (newStep) => {
      setProgress((prev) => {
        let newProgress = { ...prev };
        if (newStep <= 4) {
          newProgress.focus = Math.min(prev.focus + 15, 65);
        } else if (newStep <= 7 && popupProgress.focus) {
          newProgress.focus = 100;
          newProgress.insight = Math.min(prev.insight + 15, 66);
        } else if (newStep <= 13 && popupProgress.insight) {
          newProgress.insight = 100;
          newProgress.action = Math.min(prev.action + 15, 66);
          console.log("newStep <= 13");
        } else if (
          newStep <= 18 &&
          popupProgress.focus &&
          popupProgress.insight
        ) {
          newProgress.action = 100;
        }
        newProgress.overall =
          (newProgress.focus + newProgress.insight + newProgress.action) / 3;
        return newProgress;
      });
    },
    [popupProgress.focus, popupProgress.insight]
  );

  const calculateRemainingTime = useCallback((current_time, end_time) => {
    const endTime = new Date(end_time).getTime();
    const currentTime = new Date(current_time).getTime();
    return endTime - currentTime;
  }, []);

  const simulateTyping = useCallback((text, callback) => {
    if (!text) {
      console.error("Error: Text is null or undefined.");
      setBotTyping(false);
      return;
    }

    let typedText = "";
    const delayPerWord = 0; // Adjust timing for better effect
    const words = text.split(" ");

    words.forEach((word, index) => {
      setTimeout(() => {
        typedText += word + " ";

        setMessages((prevMessages) => {
          const filteredMessages = prevMessages.filter(
            (msg) => msg.from !== "bot"
          );
          return [...filteredMessages, { from: "bot", text: typedText.trim() }];
        });
        if (index === words.length - 1) {
          setTimeout(() => {
            setBotTyping(false);
            // Wait for textarea to render
            setTimeout(() => {
              if (textareaRef.current) {
                textareaRef.current.focus();
              }
              callback && callback();
            }, 50); // slight delay to allow rendering
          }, 500);
        }
      }, index * delayPerWord);
    });
  }, []);

  const checkCreateSession = useCallback(async () => {
    if (!user.user_id) {
      navigate("/signUp");
    } else {
      const res = await fetch(`${apiBaseURL}/users/${user.user_id}/session`, {
        method: "GET",
      });
      console.log("session is checked for ongoing session");
      const session = await res.json();
      console.log(session);
      if (session.current_Session) {
        const {
          session_id,
          current_time,
          end_time,
          extended,
          coach_name,
          last_msg,
          session_goal,
          step_number,
        } = session;
        setNewSession(session_id);
        setSessionExtend(extended);
        console.log(coach_name);
        // let stepPoints = 0;

        let newFocus = 0;
        let newInsight = 0;
        let newAction = 0;

        if (step_number <= 7) {
          // Case 1: Step number is 7 or below
          if (session.popup_required) {
            newFocus = 100;
            newInsight = session.insight ? 100 : 100 - 12 * (12 - step_number);
          } else {
            newFocus = 65 - 12 * (7 - step_number);
          }
        } else if (step_number <= 12) {
          // Case 2: Step number is between 8 and 12
          if (session.insight) {
            newFocus = 100;
            newInsight = 100;
            newAction = 65 - 15 * (12 - step_number);
          } else {
            newFocus = 100;
            newInsight = 65 - 15 * (12 - step_number);
          }
        } else if (step_number <= 17) {
          // Case 3: Step number is between 13 and 17
          newFocus = 100;
          newInsight = 100;
          newAction = 65 - 15 * (17 - step_number);
        }

        // ✅ Update Progress States
        setProgress((prev) => ({
          ...prev,
          focus: Math.max(prev.focus, newFocus),
          insight: Math.max(prev.insight, newInsight || 0),
          action: Math.max(prev.action, newAction || 0),
        }));
        setPopupProgress((prev) => ({
          ...prev,
          focus: session.popup_required === 1 ? true : prev.focus, // If focusValue is 1, set focus to 100
          insight: session.insight ? true : prev.insight, // If insightValue is true, set insight to 100
        }));
        setTotalStepNumber(step_number ?? 0);

        setIsPopupRequired(session.popup_required);
        const coachImageSrc = coachImages[coach_name.toLowerCase()];
        const coach_det = {
          name: coach_name,
          imgSrc: coachImageSrc,
        };
        setSelectedCoach(coach_det);
        setSelectedCoach(coach_det);

        if (session.insight_popup) {
          setInsightPopup(true); // Set the state to true
          setInsightPopupData({
            Question1: session.Question1 || [], // Ensure fallback to empty array
            Question2: session.Question2 || [], // Ensure fallback to empty array
          });
          setinsightStepNumber(session.step_number);
          setinsightSummery(session.insight_summery);
          console.log("this is 2popup", insightPopupData);
          console.log("this is 2popup data ", session.Question1);
          console.log("this is 2popup data ", session.Question2);
        }

        if (session.action_popup) {
          setactionPopup(true); // Set the state to true
          setActionPopupOptions(session.action_options);
          console.log("this is 3 popup data ", session.action_options);
        }

        if (session.conclution_popup) {
          setConclutionPopup(true); // Set the state to true
          setActionData(session.conclusion.session_actions);
          setInsightData(session.conclusion.session_insights);
          // setSessionGoal(data.conclusion.session_goal);
          setInsightFromUser(session.question_response);
          console.log("this is 3 popup data ", session.action_options);
        }

        if (session_goal) {
          setSession_Goal(session_goal);
        }
        if (
          session.focus_options ||
          session.conversation_summary ||
          session.alternate_focus_hypothesis
        ) {
          setPopupSummary(
            session.conversation_summary || "No summary provided."
          );
          setPopupOptions(
            session.focus_options || ["No focus options available."]
          );
          setPopupAlternatePerspective(
            session.alternate_focus_hypothesis ||
              "No alternate perspective provided."
          );
          setIsPopupVisible(true);
        }

        if (messages.length === 0) {
          const welcomeMessage = last_msg
            ? last_msg
            : `Tell me what problem are you facing.`;
          simulateTyping(welcomeMessage, () => {
            setBotTyping(false);
            setUserTyping(true);
          });
        }

        setLoading(false);

        const remainingTime = calculateRemainingTime(current_time, end_time);
        console.log(session_id, remainingTime);
        setRemainingTime(remainingTime);

        setTimeout(() => {
          setSessionExpired(true);
        }, remainingTime);

        console.log(`Session will expire in ${remainingTime / 60000} min`);
      } else {
        console.log(
          "No active session found — creating with defaults (coach: Eira, mood: more)"
        );
        // Auto-create a session without showing mood/coach selection
        setShowCoachPopup(false);
        await createSession({
          coachName: "Eira",
          selectedTime: 21,
          currentModule,
        });
      }
    }
  }, [
    user.user_id,
    navigate,
    apiBaseURL,
    coachImages,
    simulateTyping,
    calculateRemainingTime,
  ]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    checkCreateSession();
  }, [checkCreateSession]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (session_Goal && !hasConfettiShown) {
      setShowConfetti(true);
      setHasConfettiShown(true);
      setTimeout(() => {
        setShowConfetti(false);
      }, 5000);
      setTimeout(() => {
        setShowConfetti(true);
        setTimeout(() => {
          setShowConfetti(false);
        }, 3000);
      }, 3000);
    }
  }, [session_Goal, hasConfettiShown]);

  useEffect(() => {
    const savedImage = localStorage.getItem("selectedImage");
    if (savedImage) {
      console.log(` this is the set image ${savedImage}`);
      setImage(savedImage);
    }
  }, []);

  useEffect(() => {
    if (newMessage.trim() !== "") {
      if (!startTime) {
        setStartTime(Date.now());
      }
      if (botQuestionTimestamp) {
        const currentTime = Date.now();
        const comprehensionTime = currentTime - botQuestionTimestamp;
        setComprehensionTimes((prevTimes) => [...prevTimes, comprehensionTime]);
        setBotQuestionTimestamp(null);
      }
    } else {
    }
  }, [newMessage, startTime, botQuestionTimestamp]);

  useEffect(() => {
    if (sessionExpired) {
      const avgWPM = calculateAverageWPM();
      console.log("Average WPM:", avgWPM);
      const avgComprehensionTime = calculateAverageComprehensionTime();
      console.log(
        `Average comprehension time: ${avgComprehensionTime / 1000} seconds`
      );
      saveSessionData(
        Math.round(avgWPM),
        Math.round(avgComprehensionTime / 1000)
      );
    }
  }, [
    sessionExpired,
    calculateAverageWPM,
    calculateAverageComprehensionTime,
    saveSessionData,
  ]);

  useEffect(() => {
    if (remainingTime !== null && remainingTime > 0) {
      const timer = setInterval(() => {
        setRemainingTime((prevTime) => Math.max(prevTime - 60000, 0));
      }, 60000);
      return () => clearInterval(timer);
    }
  }, [remainingTime]);

  const speakText = (text) => {
    if ("speechSynthesis" in window) {
      const speech = new SpeechSynthesisUtterance(text);
      speech.lang = "en-US";
      speech.rate = 1;
      speech.pitch = 1;
      speech.volume = 1;
      window.speechSynthesis.speak(speech);
    } else {
      alert("Sorry, your browser does not support Text-to-Speech!");
    }
  };

  const createSession = async (coach) => {
    setLoading(true);
    try {
      const resolvedModule =
        coach?.currentModule !== undefined && coach?.currentModule !== null
          ? Number(coach.currentModule)
          : currentModule !== undefined && currentModule !== null
          ? Number(currentModule)
          : null;

      const normalizedModule = Number.isFinite(resolvedModule)
        ? resolvedModule
        : null;

      let res;
      const baseURL = story_id
        ? `${apiBaseURL}/users/${user.user_id}/session/create/${coach.coachName}/${coach.selectedTime}/${currentMood}/${story_id}`
        : `${apiBaseURL}/users/${user.user_id}/session/create/${coach.coachName}/${coach.selectedTime}/${currentMood}`;

      let sessionURL = baseURL;
      if (normalizedModule !== null) {
        try {
          const urlObj = new URL(baseURL);
          urlObj.searchParams.set("currentModule", normalizedModule);
          sessionURL = urlObj.toString();
        } catch (err) {
          console.warn("Unable to append currentModule to session URL:", err);
          sessionURL = `${baseURL}${
            baseURL.includes("?") ? "&" : "?"
          }currentModule=${normalizedModule}`;
        }
      }

      res = await fetch(sessionURL, {
        method: "GET",
      });

      if (story_id) {
        console.log("Called continue session API with story_id:", story_id);
      }

      if (!res.ok) {
        let detail = "";
        try {
          const err = await res.json();
          detail = err?.detail || JSON.stringify(err);
        } catch (e) {}
        throw new Error(`Failed to create session: ${detail}`);
      }

      const createSession = await res.json();
      console.log("Session created:", createSession);
      checkCreateSession();
      console.log("sessio will be created in a min");
    } catch (error) {
      console.error("Error creating session:", error);
    }
  };

  const handleCoachSelection = async (coach) => {
    setSelectedCoach(coach);
    createSession({ ...coach, currentModule });
    setShowCoachPopup(false);
  };

  const continueSession = async () => {
    if (sessionExtend) {
      console.log("Session has been extended once.");
      navigate("/");
    } else {
      try {
        const res = await fetch(
          `${apiBaseURL}/users/session/${newSession}/extend`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!res.ok) {
          // Log the error status and response body
          const errorData = await res.json();
          console.error("Failed to extend session:", errorData);
          throw new Error(errorData.detail || "Unknown error occurred");
        }

        const extendedSession = await res.json();
        setSessionExtend(extendedSession);
        setSessionExpired(false);
        checkCreateSession();
      } catch (error) {
        console.log("The session was not able to extend:", error.message);
        navigate("/");
      }
    }
  };

  // useEffect(() => {
  //   const handleUnload = (sessionId) => {
  //     // const sessionId = localStorage.getItem("newSession"); // Or from props/state
  //     console.log("this is the session that is being terminated", sessionId);
  //     if (!sessionId) return;

  //     const url = `${process.env.REACT_APP_BACKEND_API_URL}/users/session/${sessionId}/end`;

  //     const data = JSON.stringify({ closed_at: new Date().toISOString() });
  //     const blob = new Blob([data], { type: "application/json" });

  //     // Prefer POST: change backend if needed
  //     navigator.sendBeacon(url, blob);
  //   };

  //   window.addEventListener("unload", handleUnload(newSession));

  //   return () => {
  //     window.removeEventListener("unload", handleUnload(newSession));
  //   };
  // }, []);

  const endSession = async () => {
    try {
      const res = await fetch(`${apiBaseURL}/users/session/${newSession}/end`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const exitSession = await res.json();
      console.log(exitSession);
      console.log("session Ended using sessionid ");
      navigate("/");
    } catch (error) {
      console.log("The session has ended:", error.message);
      navigate("/");
    }
  };

  const handleSendMessage = async () => {
    setIsDisabled(true);
    setResponseReceived(false);
    if (newMessage.trim() !== "") {
      const newStep = totalStepNumber;
      updateProgress(newStep);
      setTotalStepNumber(totalStepNumber + 1);
    }
    if (newMessage.trim() !== "") {
      const endTime = Date.now();
      const timeTaken = (endTime - startTime) / 1000;
      const wordCount = newMessage.trim().split(/\s+/).length;
      const wpm = (wordCount * 60) / timeTaken;
      setWpmHistory((prevHistory) => [...prevHistory, wpm]);
      setTotalResponses((prevResponses) => prevResponses + 1);
      setStartTime(null);
      // const messageToSend = newMessage;
      const userMessage = { from: "user", text: newMessage };
      setMessages((prevMessages) => [...prevMessages, userMessage]);
      setBotTyping(true);
      setthubsUp(true);
      setthubsDown(true);
      setBotTyping(true);

      const payload = {
        coachee_response: newMessage,
        focus_popup_required: isPopupRequired,
        record_from_focus_popup: 0,
        selected_focus_choice: 1,
        conversation_summary: "",
        regenerate_with_intention: false,
        focus_options: "",
        alternate_focus_hypothesis: "",
      };
      let retryCount = 0;
      const maxRetries = 6;
      const sendRequest = async () => {
        try {
          const response = await fetch(
            `${apiBaseURL}/users/${user.user_id}/session/${newSession}/step`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            }
          );
          const data = await response.json();
          console.log("This is the data", data);
          if (response.ok) {
            const newStep = {
              step_number: data.step_number,
              coachee_response: newMessage,
              coach_response: data.coach_response,
              user_tags: data.user_tags ? data.user_tags.join(",") : "",
              intention: data.intention,
              technique: data.technique,
              popup_required: data.popup_required,
            };
            setIsPopupRequired(newStep.popup_required);
            if (data.insight_popup) {
              setInsightPopup(true); // Set the state to true
              setInsightPopupData({
                Question1: data.Question1 || [], // Ensure fallback to empty array
                Question2: data.Question2 || [], // Ensure fallback to empty array
              });
              setinsightStepNumber(data.step_number);
              setinsightSummery(data.insight_summery);
              console.log("this is 2popup", insightPopupData);
              console.log("this is 2popup data ", data.Question1);
              console.log("this is 2popup data ", data.Question2);
            }
            if (data.action_popup) {
              setactionPopup(true);
              setActionPopupOptions(data.action_options);
              setActionSummery(data.action_summery);
            }
            if (data.session_goal !== null) {
              setSession_Goal(data.session_goal);
            }
            setBotResponse(data.coach_response);
            if (
              data.focus_options ||
              data.conversation_summary ||
              data.alternate_focus_hypothesis
            ) {
              setPopupSummary(
                data.conversation_summary || "No summary provided."
              );
              setPopupOptions(
                data.focus_options || ["No focus options available."]
              );
              setPopupAlternatePerspective(
                data.alternate_focus_hypothesis ||
                  "No alternate perspective provided."
              );
              setIsPopupVisible(true);
            }
            console.log("Popup Options:", data.focus_options);
            console.log("Summary:", data.conversation_summary);
            console.log(
              "Alternate Perspective:",
              data.alternate_focus_hypothesis
            );
            setUserTyping(false);
            setBotTyping(false);
            setNewMessage("");
            simulateTyping(data.coach_response, () => {
              setUserTyping(true);
              setIsDisabled(false);
              setUserReaction("Neutral");
            });
          } else {
            retryCount++;
            if (retryCount < maxRetries) {
              sendRequest();
            } else {
              setMessages((prevMessages) => [
                ...prevMessages,
                { from: "bot", text: "Sorry, no response found." },
              ]);
              setBotTyping(false);
            }
          }
        } catch (error) {
          retryCount++;
          if (retryCount < maxRetries) {
            sendRequest();
          } else {
            setMessages((prevMessages) => [
              ...prevMessages,
              {
                from: "bot",
                text: "An error occurred while processing your request.",
              },
            ]);
            setBotTyping(false);
          }
        }
      };
      sendRequest();
    }
  };

  const handleTextareaKeyDown = (event) => {
    if (event.key === "Enter" && event.ctrlKey) {
      event.preventDefault();
      if (newMessage.trim() !== "" && !botTyping) {
        handleSendMessage();
      }
    }
  };

  const handleRegenerateResponse = async (stepNumber) => {
    try {
      setIsDisabled(true);
      setBotTyping(true);

      const payload = {
        coachee_response: "",
        focus_popup_required: isPopupRequired,
        record_from_focus_popup: 0,
        selected_focus_choice: 1,
        regenerate_with_intention: true,
        focus_options: "",
        alternate_focus_hypothesis: "",
      };

      const response = await fetch(
        `${apiBaseURL}/users/${user.user_id}/session/${newSession}/step`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      if (response.ok) {
        setBotResponse(data.coach_response);

        // Simulate typing before updating the UI
        simulateTyping(data.coach_response, () => {
          setBotTyping(false);
          setIsDisabled(false);
        });
      } else {
        console.error("Error in regeneration:", data.detail);
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            from: "bot",
            text: "An error occurred while regenerating the coach response.",
          },
        ]);
        setBotTyping(false);
      }
    } catch (error) {
      console.error("Error during regeneration:", error);
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          from: "bot",
          text: "An error occurred while processing your request.",
        },
      ]);
      setBotTyping(false);
    }
  };

  const handleFocusOptionSubmit = async (selectedOption, selectedIndex) => {
    setPopupProgress((prev) => ({ ...prev, focus: true }));
    setProgress((prev) => ({ ...prev, focus: 100 }));
    setSession_Goal(selectedOption);
    setSelectedFocusChoice(selectedOption);
    setIsPopupVisible(false);
    const payload = {
      coachee_response: String(selectedOption),
      focus_popup_required: isPopupRequired ? 1 : 0,
      record_from_focus_popup: 1,
      selected_focus_choice: selectedIndex,
      conversation_summary: popupSummary || null,
      focus_options: popupOptions || null,
      alternate_focus_hypothesis: popupAlternatePerspective || null,
      regenerate_with_intention: false,
    };
    setBotTyping(true);
    try {
      const response = await fetch(
        `${apiBaseURL}/users/${user.user_id}/session/${newSession}/step`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      if (!response.ok) {
        console.error("Error response:", data);
        setBotTyping(false);
        setMessages((prevMessages) => [
          ...prevMessages,
          { from: "bot", text: "Sorry, no response found." },
        ]);
        return;
      }
      const newStep = {
        step_number: data.step_number,
        coachee_response: String(selectedOption),
        coach_response: data.coach_response,
        user_tags: data.user_tags ? data.user_tags.join(",") : "",
        intention: data.intention,
        technique: data.technique,
        popup_required: data.popup_required,
      };
      setIsPopupRequired(newStep.popup_required);
      setBotResponse(data.coach_response);
      if (
        data.focus_options ||
        data.conversation_summary ||
        data.alternate_focus_hypothesis
      ) {
        setPopupSummary(data.conversation_summary || "No summary provided.");
        setPopupOptions(data.focus_options || ["No focus options available."]);
        setPopupAlternatePerspective(
          data.alternate_focus_hypothesis ||
            "No alternate perspective provided."
        );
        setIsPopupVisible(true);
      }
      simulateTyping(data.coach_response, () => {
        setBotTyping(false);
        setIsDisabled(false);
        setNewMessage("");
        setUserReaction("Neutral");
      });
    } catch (error) {
      console.error("Error submitting focus option:", error);
      setBotTyping(false);
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          from: "bot",
          text: "An error occurred while processing your request.",
        },
      ]);
    }
  };

  const handleinsightPopupSubmit = async (user_response) => {
    try {
      setPopupProgress((prev) => ({ ...prev, insight: true }));
      setProgress((prev) => ({ ...prev, insight: 100 }));
      setIsDisabled(true);
      setBotTyping(true);

      const payload = {
        coachee_response: user_response,
        focus_popup_required: isPopupRequired,
        record_from_focus_popup: 0,
        selected_focus_choice: 21,
        regenerate_with_intention: false,
        focus_options: "",
        alternate_focus_hypothesis: "",
        conversation_summary: "",
      };

      const response = await fetch(
        `${apiBaseURL}/users/${user.user_id}/session/${newSession}/step`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      if (response.ok) {
        setBotResponse(data.coach_response);
        setInsightPopup(false);
        // Simulate typing before updating the UI
        simulateTyping(data.coach_response, () => {
          setBotTyping(false);
          setIsDisabled(false);
        });
      } else {
        console.error("Error in regeneration:", data.detail);
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            from: "bot",
            text: "An error occurred while regenerating the coach response.",
          },
        ]);
        setBotTyping(false);
      }
    } catch (error) {
      console.error("Error during regeneration:", error);
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          from: "bot",
          text: "An error occurred while processing your request.",
        },
      ]);
      setBotTyping(false);
    }
  };

  const remainingMinutes =
    remainingTime !== null ? Math.floor(remainingTime / 60000) : null;

  const textareaRef = useRef(null);

  useEffect(() => {
    if (!botTyping && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [botTyping]);

  return (
    <div className="relative w-full h-full flex flex-col bg-white font-gotham">
      {/* CONFETTI */}
      {showConfetti && (
        <div className="absolute inset-0 z-40">
          <Confetti
            width={window.innerWidth}
            height={window.innerHeight}
            colors={[
              "#2B6CB0",
              "#3182CE",
              "#63B3ED",
              "#319795",
              "#38B2AC",
              "#81E6D9",
              "#ECC94B",
              "#D69E2E",
              "#F6E05E",
            ]}
          />
        </div>
      )}

      {/* LOADING OVERLAY */}
      {loading && (
        <div
          className={`${
            embedded ? "absolute" : "fixed"
          } inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center`}
        >
          <div className="text-white text-xl font-semibold">Loading...</div>
        </div>
      )}

      {/* COACH SELECTION */}
      {showCoachPopup &&
        (showMood ? (
          <Mood
            onClose={(mood) => {
              setCurrentMood(mood);
              setShowMood(!showMood);
            }}
          />
        ) : (
          <OnboardingMain
            onSelectCoach={handleCoachSelection}
            userId={user.user_id}
          />
        ))}

      {/* FOCUS POPUP */}
      {isPopupVisible && (
        <FocusPopup
          summary={popupSummary}
          options={popupOptions}
          alternatePerspective={popupAlternatePerspective}
          backstory={popupCoachBackstory}
          onClose={handleFocusOptionSubmit}
          newSession={newSession}
          userId={user?.user_id}
          apiBaseURL={apiBaseURL}
        />
      )}

      {/* CONCLUSION POPUP */}
      {conclutionPopup && (
        <Conclusion
          conclusion={conclusionData}
          action={actionData}
          insight={insightData}
          yourInsight={insightFromUser}
          session_goal={session_Goal}
          newSession={newSession}
          userId={userId}
          subsectionId={subsectionId}
          onSessionComplete={onSessionComplete}
        />
      )}

      {/* INSIGHT POPUP */}
      {insightPopup && (
        <InsightPopup
          summary={insightSummery}
          questions={insightPopupData}
          isVisible={insightPopup}
          newSession={newSession}
          step_number={insightStepNumber}
          onClose={handleinsightPopupSubmit}
          onEndSession={endSession}
          session_Goal={session_Goal}
          userId={userId}
          subsectionId={subsectionId}
          onSessionComplete={onSessionComplete}
        />
      )}

      {/* ACTION POPUP */}
      {actionPopup && (
        <ActionPopup
          summary={actionSummery}
          options={actionPopupOptions}
          backstory={popupCoachBackstory}
          newSession={newSession}
          session_Goal={session_Goal}
          userId={userId}
          subsectionId={subsectionId}
          onSessionComplete={onSessionComplete}
        />
      )}

      {/* SHIZUN – anchored inside card, bottom-left */}
      <div className="hidden md:flex flex-col items-center absolute bottom-6 left-0 z-20">
        <img
          src={sizun}
          alt="Shizun"
          className="w-28 md:w-32 lg:w-36 h-[204px] object-contain"
        />
        <div className="text-gray-800 font-semibold text-[24px] mt-1">
          Shizun
        </div>
        <div className="text-gray-400 text-[14px] tracking-wide uppercase">
          Reflection Guide
        </div>
      </div>

      {/* MAIN COLUMN – fills the card height */}
      <div className="flex flex-col flex-1 pt-8 pb-6 px-4 md:px-10 lg:px-16 ml-8">
        {/* PROGRESS BAR */}
        <div className="relative w-full mb-10 mt-6 md:mt-0 -ml-8">
          <div className="relative flex items-center w-full mb-10">
            {["focus", "insight", "action"].map((key, index) => (
              <div key={index} className="relative flex-1 flex items-center">
                <div className="h-2 flex-1 bg-gray-300 rounded-full">
                  <div
                    className={`h-full transition-all duration-500 ${
                      progress[key] > 0 ? "bg-[#54B0AF]" : "bg-gray-300"
                    }`}
                    style={{ width: `${progress[key]}%` }}
                  ></div>
                </div>
                <div className="absolute -right-5 transform -translate-x-1/2 -top-4 bg-white p-2 rounded-full">
                  {index === 0 && <Gift className="w-6 h-6 text-gray-500" />}
                  {index === 1 && (
                    <PartyPopper className="w-6 h-6 text-gray-500" />
                  )}
                  {index === 2 && <Flag className="w-6 h-6 text-gray-500" />}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CHAT AREA (messages + textarea) */}
        <div className="flex-1 flex flex-col w-full max-w-4xl mx-auto space-y-4">
          {session_Goal && (
            <div className="w-full max-w-4xl mx-auto">
              <div className="rounded-2xl bg-[#F5F9F9] border border-[#DCEEEE] px-4 py-3 text-sm md:text-base text-[#323232]">
                <span className="font-semibold text-[#246F6E] mr-2">
                  Session Goal
                </span>
                <span>{session_Goal}</span>
              </div>
            </div>
          )}

          {/* Messages */}
          <div className="flex flex-col gap-4">
            {botTyping ? (
              <>
                <div className="w-full h-16 rounded-2xl bg-gray-200 animate-pulse"></div>
                <div className="w-full h-16 rounded-2xl bg-gray-200 animate-pulse"></div>
              </>
            ) : (
              <>
                {messages
                  .filter((msg) => msg.from === "bot")
                  .map((message, index) => (
                    <ChatBubble key={index} message={message} isBot />
                  ))}

                {messages.length > 0 &&
                  messages[messages.length - 1].from === "user" && (
                    <ChatBubble
                      message={messages[messages.length - 1]}
                      isBot={false}
                      showToast={showToast}
                    />
                  )}
              </>
            )}
          </div>

          {/* TEXTAREA */}
          {!botTyping && (
            <div className="w-full max-w-4xl mx-auto mt-4">
              <textarea
                ref={textareaRef}
                value={newMessage}
                placeholder="What’s on your mind...?"
                onChange={(e) => {
                  setNewMessage(e.target.value);
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                onKeyDown={handleTextareaKeyDown}
                className="resize-none w-full h-full text-lg md:text-xl font-gotham text-[#484848] 
                 leading-relaxed p-3 outline-none bg-transparent overflow-hidden"
              />
            </div>
          )}
        </div>

        {/* BOTTOM ACTION ROW */}
        <div className="mt-auto pt-6 w-full max-w-4xl mx-auto flex items-center justify-between">
          {/* RESPOND BUTTON — left aligned */}
          <button
            onClick={handleSendMessage}
            disabled={newMessage.trim() === "" || botTyping}
            className={`${
              newMessage.trim() === "" || botTyping
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#54b0af]"
            } text-white font-semibold text-base md:text-lg lg:text-xl px-10 py-3 rounded-full shadow flex items-center gap-2`}
          >
            Respond
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={3}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>

          {/* EXIT BUTTON — right aligned */}
          <button
            onClick={() => setSessionEnd(true)}
            className="flex items-center gap-2 text-gray-600 font-semibold text-base md:text-lg lg:text-xl uppercase tracking-wide"
          >
            EXIT
          </button>
        </div>
      </div>

      {/* SESSION POPUPS */}
      {sessionExpired && (
        <SessionExpiredPopup
          onContinueSession={continueSession}
          onEndSession={endSession}
          onClose={() => setSessionExpired(false)}
          newSession={newSession}
          sessionExtend={sessionExtend}
        />
      )}

      {sessionEnd && (
        <EndSessionPopup
          onEndSession={endSession}
          onClose={() => setSessionEnd(false)}
          onExitSession={onExitSession}
          newSession={newSession}
          onSessionComplete={onSessionComplete}
          userId={userId}
          subsectionId={subsectionId}
        />
      )}
    </div>
  );
};

const ChatBubble = ({ message, isBot }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scaleY: 0, transformOrigin: "top" }}
      animate={{ opacity: 1, scaleY: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className={`flex ${isBot ? "justify-start" : "justify-end"} items-center`}
    >
      <div
        className={`relative ${
          isBot ? "text-gray-900" : "text-gray-800"
        } font-[700] font-quattrocento text-xl md:text-2xl lg:text-3xl `}
      >
        <span className=" text-lg md:text-xl lg:text-2xl font-quattrocento leading-[10px] md:leading-5 font-[600] md:font-[700]">
          {message.text}
        </span>
      </div>
    </motion.div>
  );
};

export default ChatWindow;
